var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgTxArrow = function SvgTxArrow(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 8 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M3.646 108.354a.5.5 0 0 0 .708 0l3.182-3.182a.501.501 0 0 0-.708-.708L4 107.293l-2.828-2.829a.5.5 0 0 0-.708.708l3.182 3.182ZM3.5 0v1h1V0h-1Zm0 3v2h1V3h-1Zm0 4v2h1V7h-1Zm0 4v2h1v-2h-1Zm0 4v2h1v-2h-1Zm0 4v2h1v-2h-1Zm0 4v2h1v-2h-1Zm0 4v2h1v-2h-1Zm0 4v2h1v-2h-1Zm0 4v2h1v-2h-1Zm0 4v2h1v-2h-1Zm0 4v2h1v-2h-1Zm0 4v2h1v-2h-1Zm0 4v2h1v-2h-1Zm0 4v2h1v-2h-1Zm0 4v2h1v-2h-1Zm0 4v2h1v-2h-1Zm0 4v2h1v-2h-1Zm0 4v2h1v-2h-1Zm0 4v2h1v-2h-1Zm0 4v2h1v-2h-1Zm0 4v2h1v-2h-1Zm0 4v2h1v-2h-1Zm0 4v2h1v-2h-1Zm0 4v2h1v-2h-1Zm0 4v2h1v-2h-1Zm0 4v2h1v-2h-1Zm0 4v1h1v-1h-1Z",
    fill: "currentColor"
  })));
};
export default SvgTxArrow;